<template>
  <div class="main">
    <div class="head">
      <div class="title">东体安全管理大屏幕</div>
      <dv-decoration-3 class="decoration left" />
      <dv-decoration-3 class="decoration right" />
    </div>
    <a-row class="body" :gutter="12">
      <a-col span="5">
        <div class="left">
          <div class="box-title">
            <div>场馆概况</div>
          </div>
          <left />
        </div>
      </a-col>
      <a-col span="14">
        <div class="middle">
          <div class="top">
            <middle-top />
          </div>
          <div class="bottom">
            <div class="box-title">
              <div>救生员岗位情况</div>
            </div>
            <middle-bottom />
          </div>
        </div>
      </a-col>
      <a-col span="5">
        <div class="right">
          <div class="top">
            <div class="box-title">
              <div>登录</div>
            </div>
            <right-top />
          </div>
          <div class="bottom">
            <div class="box-title">
              <div>报警信息</div>
            </div>
            <right-bottom />
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import Left from './left'
import MiddleTop from './middleTop'
import MiddleBottom from './middleBottom'
import RightTop from './rightTop'
import RightBottom from './rightBottom'

export default {
  components: { MiddleTop, Left, RightTop, RightBottom, MiddleBottom },
  mounted() {},
  data() {
    return {}
  },
  methods: {},
}
</script>

<style lang="less" scoped>
.main {
  .warn-dialog {
    position: absolute;
    top: -10%;
    left: -3%;
    width: 240px;
    z-index: 99;
    background: url(../../assets/dongti/warn-bg.png) no-repeat center center/100% 100%;
    padding: 15px;
    .title {
      position: relative;
    }
    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 80%;
      }
    }
    .name {
      font-weight: bold;
      font-size: 16px;
      text-align: center;
      margin: 12px 0;
    }
    .btn-area {
      margin-top: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.stadium {
  position: fixed;
  left: 26%;
  top: 100px;
  width: 20%;
  height: auto;
  background: #046d93;
  border: 1px solid #7ad9ff;
  padding: 20px 15px;
  color: #03bce2;
  z-index: 999;
  .name {
    font-size: 18px;
    margin-bottom: 12px;
    width: 100%;
    position: relative;
    .sname {
      display: block;
    }
    .icon {
      position: absolute;
      top: -12px;
      right: 0px;
      font-size: 20px;
    }
  }
  .citem {
    font-size: 14px;
    padding: 6px 0;
  }
  .btn-area {
    margin-top: 12px;
  }
}
.main {
  background: #000729 url(../../assets/dongti/border.png);
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  box-sizing: border-box;
  .head {
    width: 100%;
    height: 8.5vh;
    background: url(../../assets/head-bg.png) no-repeat center center/100% 100%;
    position: relative;
    .title {
      font-size: 3.5vh;
      text-align: center;
      padding-top: 1vh;
      color: #fff;
      text-shadow: 0 2px 4px #042240;
    }
    .decoration {
      width: 16vw;
      height: 4vh;
      position: absolute;
      bottom: 0.7vh;
      &.left {
        left: 8vw;
      }
      &.right {
        right: 8vw;
      }
    }
  }
  .body {
    padding: 4px 12px 16px;
    height: 91.5vh;
    box-sizing: border-box;
    > div {
      height: 100%;
    }
    .left {
      width: 100%;
      height: 100%;
      background: url(../../assets/dongti/left.png) no-repeat center center;
      background-size: 100% 100%;
    }
    .middle {
      width: 100%;
      height: 100%;
      .top {
        height: 58vh;
        background: url(../../assets/dongti/middle-t.png) no-repeat center center/100% 100%;
      }
      .bottom {
        margin-top: 1vh;
        width: 100%;
        height: 31vh;
        background: url(../../assets/dongti/middle-b.png) no-repeat center center/100% 100%;
        .box-title {
          padding: 2vh 2.2vw 0;
        }
      }
    }
    .right {
      width: 100%;
      height: 100%;
      .top {
        height: 34vh;
        background: url(../../assets/dongti/right-t.png) no-repeat center center/100% 100%;
      }
      .bottom {
        margin-top: 1vh;
        width: 100%;
        height: 55vh;
        background: url(../../assets/dongti/right-b.png) no-repeat center center/100% 100%;
        background-size: 100% 100%;
      }
    }
  }
  .box-title {
    font-size: 24px;
    color: #fff;
    padding: 1.8vh 2.2vw 0;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &::before {
      content: ' ';
      position: absolute;
      left: 1.4vw;
      top: 2.5vh;
      width: 7px;
      height: 2.6vh;
      background: #47f7f4;
      border-radius: 4px;
    }
  }
}
</style>
